$('document').ready(function() {

    //****************************************************************************
	// Applique une animation de deplacement entre les liens pointant sur une ancre et leur ancre (href='#ancre').
	$('a[data-animate=true]').click(function()
	{
		var linkPathName = this.pathname;

		if (linkPathName == "")
		{
			this.pathname = location.pathname;	// S'assure que les liens pointant vers les ancres (entrees via le CMS) contiennent le chemin complet de la page.
		}

		if (location.hostname == this.hostname)
		{
			var $target = $(this.hash);
			$target = $target.length && $target || $('[id=' + this.hash.slice(1) +']');
			if ($target.length)
			{
				var targetOffset = $target.offset().top;
				$('html,body').animate({scrollTop: targetOffset-20}, 500);
				return false;
			}
		}
	});
});
